import axiosInstance from './Api';

export default {

  getModules: async (payload) => axiosInstance().get(`/api/admin/user-management/modules`, { params: payload }),

  getAllRoles: async (payload) => axiosInstance().get(`/api/admin/user-management/roles`, { params: payload }),

  getSingleRole: async (payload) => axiosInstance().get(`/api/admin/user-management/roles/${payload.role_id}`),

  saveRole: async (payload) => axiosInstance().post(`/api/admin/user-management/roles`, payload)

}



// WEBPACK FOOTER //
// ./src/services/UserManagmentServices.js